import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';
const Findhelp = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000'; 
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }    
    const queryParams = new URLSearchParams(location.search);
    const MemberFirstName = queryParams.get('MemberFirstName');
    const MemberLastName = queryParams.get('MemberLastName');
    const UserId = queryParams.get('UserId');
    const CId = queryParams.get('CID');     
    fetchHelpURL(MemberFirstName, MemberLastName, UserId, CId);  
  }, [location]);
  const fetchHelpURL = async (MemberFirstName, MemberLastName, UserId, CId) => {
    try {
      console.log('API Call Parameters:', {
        MemberFirstName: MemberFirstName || '',
        MemberLastName: MemberLastName || '',
        UserId: UserId || '',
        CId: CId || ''
      });
      const response = await axios.get(`${API_URL}/api/FindHelp/GetFindHelpUrl`, {
        params: {
          MemberFirstName: MemberFirstName || '',
          MemberLastName: MemberLastName || '',
          UserId: UserId || '',
          CId: CId || ''
        }
      });      
      setLoading(false);     
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        setError('findhelp');
      }
    } catch (error) {
      console.error('Error fetching Find Help URL:', error);
      setError('findhelp');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="findhelp" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && <img src={LoadingImage} id="loadinggif" style={{alignContent: 'center'}} alt="Loading" />}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Findhelp;